<template>
  <div>
    <div class="relative">
      <div class="product-list-header">
        <slot />
        <span v-if="showNavButtons" class="absolute right-0">
          <button
            class="pi pi-angle-left w-6 h-6 py-1"
            :class="{
              'text-fh-gray-light cursor-default': !canBackward,
              'nav-button': canBackward,
            }"
            @click="previousPage"
          />

          <button
            class="pi pi-angle-right w-6 h-6 py-1 mr-2"
            :class="{
              'text-fh-gray-light cursor-default': !canForward,
              'nav-button': canForward,
            }"
            @click="nextPage"
          />
        </span>
      </div>
      <div>
        <Carousel
          ref="carousel"
          :paginationEnabled="false"
          :perPageCustom="[
            [320, sizes[2]],
            [540, sizes[1]],
            [768, sizes[0]],
          ]"
          :mouseDrag="false"
        >
          <Slide :key="'carousel_' + index" v-for="(item, index) in dataSet">
            <Product
              :show-quantity-input="showQuantityInput"
              :price-tag="priceTag"
              :price="item.price"
              :cv="item.cv"
              :type="item.type"
              :id="item.id"
              :name="item.name"
              :slug="item.slug"
              :quantity="item.quantity"
              :includes="item.includes"
              :attributes="item.attributes"
              :images="item.images"
              :settings="item.settings"
              :style="{
                'max-width':
                  productMaxWidth !== undefined ? productMaxWidth : 'none',
              }"
            />
          </Slide>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import Product from "./Product";

export default {
  components: {
    Carousel,
    Slide,
    Product,
  },
  props: {
    dataSet: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    showNav: {
      type: Boolean,
      default() {
        return true;
      },
    },
    sizes: {
      type: Array,
      default() {
        return [4, 3, 2, 1];
      },
    },
    showQuantityInput: {
      type: Boolean,
      default() {
        return true;
      },
    },
    priceTag: {
      type: String,
      default() {
        return "vertical";
      },
    },
    includes: {
      type: Array,
      default() {
        return [];
      },
    },
    attributes: {
      type: Object,
      default() {
        return {};
      },
    },
    settings: {
      type: Object,
      default() {
        return {};
      },
    },
    productMaxWidth: {
      type: String,
    },
  },
  data() {
    return {
      pageCount: 0,
      showNavButtons: true,
      currentPage: 0,
    };
  },
  computed: {
    canForward() {
      return this.currentPage < this.pageCount - 1;
    },
    canBackward() {
      return this.currentPage > 0;
    },
  },
  methods: {
    nextPage() {
      this.$refs.carousel.advancePage("forward");
      this.currentPage = this.$refs.carousel.currentPage;
    },
    previousPage() {
      this.$refs.carousel.advancePage("backward");
      this.currentPage = this.$refs.carousel.currentPage;
    },
  },
  mounted() {
    this.showNavButtons = this.showNav;
    this.pageCount = this.$refs.carousel.pageCount;
    this.currentPage = this.$refs.carousel.currentPage;
  },
};
</script>

<style lang="postcss">
.product-list-header {
  @apply my-2 py-2 w-full border-fh-gray border-2 text-center text-fh-gray;
}

.nav-button:hover {
  @apply rounded-full bg-fh-blue text-fh-pink;
}

.nav-button:disabled {
  @apply text-fh-gray-light cursor-default;
}
</style>